import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { getPrimaryColors } from 'theme/branding/custom-colors'
import ThemeProvider from 'theme/ThemeProvider'
import { AppContent } from 'components/styled/page/app-content'
import CandidateFooter from 'components/candidate-footer'
import { whiteLabelTheme } from 'theme/white-label-theme'
import { EMBEDDED_INTERVIEW_PATHS } from 'app-constants'

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  branding: PropTypes.shape({
    headerFont: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.shape({
      whitelabel: PropTypes.bool,
    }),
  }).isRequired,
}

const defaultProps = {
  httpError: null,
  children: null,
  branding: undefined,
}

const InterviewApp = ({ children, branding, location }) => {
  const {
    headerFont,
    bodyFont,
    backgroundColor,
    textColor,
    brandColor,
    buttonTextColor,
    headerTextColor,
  } = branding ?? {}

  const primaryColors = brandColor ? getPrimaryColors(brandColor) : undefined
  const customTheme = branding
    ? {
        color: {
          ...primaryColors,
          headerText: headerTextColor,
          bodyText: textColor,
          primaryButtonText: buttonTextColor,
          background: backgroundColor,
        },
        font: {
          primary: bodyFont,
          header: headerFont,
        },
      }
    : undefined

  const isEmbedPath = !!(
    location &&
    location.pathname &&
    (location.pathname.includes(EMBEDDED_INTERVIEW_PATHS.embed) ||
      location.pathname.includes(EMBEDDED_INTERVIEW_PATHS.profile))
  )
  const theme =
    isEmbedPath && location.query.whitelabel ? whiteLabelTheme : customTheme
  return (
    <ThemeProvider customTheme={theme} useGlobalStyle customizeLink>
      <AppContent footer={isEmbedPath ? null : <CandidateFooter />}>
        {children}
      </AppContent>
    </ThemeProvider>
  )
}

InterviewApp.propTypes = propTypes
InterviewApp.defaultProps = defaultProps

export default connect(state => ({
  branding: state.interview.jobOpening.company.branding,
}))(InterviewApp)
